import { GamepadRoundDownIcon } from './GamepadRoundDownIcon';

/**
 * author: Haley Halcyon
 * id ABC572E9-CE00-450F-A1E0-E59BCF0C3DC3
 * name gamepad-round-down
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round-down.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerRoundDownIcon = GamepadRoundDownIcon;
export default ControllerRoundDownIcon